import { api } from "#app/http/api";
import type { ImpactedOptimization } from "shared";

export const fetchLineRemovalImpact = async (
  lineIds: string[],
): Promise<ImpactedOptimization[]> => {
  if (lineIds.length === 0) {
    return [];
  }

  const response = await api.optimizations.previewLineRemovalImpact.mutation({
    body: { lineIds },
  });

  return response.status === 200 ? response.body.optimizations : [];
};
